import PropTypes from '@root/vendor/prop-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { P2 } from '@root/gatsby-contentful-core/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';

export function SubCopy({
  subCopy,
  subCopyIcon,
}) {
  if (!subCopy) {
    return null;
  }

  return (
    <section css={styles.heroSection}>
      {subCopy && (
        <div className={'subCopy'}>
          {subCopyIcon && (
            <GatsbyImage
              className={'subCopyIcon'}
              image={getImage(subCopyIcon)}
              imgStyle={{ objectFit: 'contain' }}
            />
          )}
          <P2>{subCopy}</P2>
        </div>
      )}
    </section>
  );
}

SubCopy.propTypes = {
  subCopy: PropTypes.string,
  subCopyIcon: PropTypes.object,
};

const styles = StyleSheet.create({
  heroSection: {
    '.subCopy': {
      display: 'flex',
      gap: 5,
      marginTop: 20,
      alignItems: 'normal',
      p: { fontWeight: 600 },
    },
    '.subCopyIcon': {
      width: 20,
      height: 20,
      marginBottom: 8,
    },
  },
});
